import React from 'react';
import styled from 'styled-components/macro';
import { colourNeutral04, colourNeutral09 } from '../styling/colours';
import { fontSize03 } from '../styling/fonts';
import { spacing06 } from '../styling/spacing';

type Props = {
  message: string;
  className?: string;
};

export const EmptyPlaceholder = (props: Props) => (
  <EmptyPlaceholderContainer className={props.className}>
    <EmptyPlaceholderMessage>{props.message}</EmptyPlaceholderMessage>
  </EmptyPlaceholderContainer>
);

const EmptyPlaceholderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${spacing06} 0;
  border: dashed 1px ${colourNeutral09};
  color: ${colourNeutral04};
`;

const EmptyPlaceholderMessage = styled.div`
  font-size: ${fontSize03};
`;
